import { Text } from '@mnd-frontend/ui';
import { memo } from 'react';
import styled from 'styled-components';
import { Legend } from '../lib/components';
import { GraphWrapper } from '../lib/components/GraphWrapper';
import { ContextProvider } from '../lib/context';
import { useColorAndId, useSortByGroup } from '../lib/hooks/data';
import { compareComponentsProps } from '../lib/utils';
import Donut from './Donut';

const ZeroState = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  & > *:first-child {
    font-weight: bold;
    font-size: 2.5rem;
    line-height: 1;
  }
`;

interface Props {
  data: { name: string; value: number; color?: string; groupId?: string }[];
  groups?: { id: string }[];
  unit: string;
  onArcClick?: (index: number) => void;
  components?: any;

  hideSummary?: boolean;
  allowEmpty?: boolean;
  height?: number;
  autoSortData?: boolean;
}

const DonutChart = memo(
  ({
    data = [],
    groups = [],
    unit,
    components,

    onArcClick,
    hideSummary = false,
    allowEmpty = false,
    height = 300,
    autoSortData = true,
  }: Props) => {
    const sortedData = useSortByGroup(data, groups);

    const coloredData = useColorAndId(autoSortData ? sortedData : data, groups);
    const chartData = allowEmpty ? coloredData : coloredData.filter(d => d.value > 0);

    return (
      <ContextProvider minWidth={300} height={height} components={components} selectShift>
        {chartData.length ? (
          <GraphWrapper horizontal>
            <Donut data={chartData} unit={unit} hideSummary={hideSummary} onArcClick={onArcClick} />
            <Legend items={chartData} groups={groups} />
          </GraphWrapper>
        ) : (
          <ZeroState>
            <Text as="p" variant="body">
              0
            </Text>
            <Text as="p" variant="body">
              {unit}
            </Text>
          </ZeroState>
        )}
      </ContextProvider>
    );
  },
  compareComponentsProps as any,
);

export default DonutChart;
